import { format } from "date-fns";

export const getTranzitIDFromSessionStorage = () => {
    const tranzitID = sessionStorage.getItem('selectedTransitLikut')
    return tranzitID ? +tranzitID : 0

}

export const calcEndDay = () => {
    let date = new Date();
    let endDate = date.setDate(date.getDate() + 7);
    let final = format(endDate, "yyyyMMdd")
    return final
}
